import React from "react"

interface StatsProps {
  total: number
  redeemed: number
  unredeemed: number
  comped?: number
}

export const Stats: React.FC<StatsProps> = ({
  total,
  redeemed,
  unredeemed,
  comped = 0,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
      <div className="text-2xl font-bold text-black-800">
        {total}
      </div>
      <div className="text-sm text-gray-600">
        Total Tickets
        {comped > 0 && (
          <span className="text-gray-400"> (including {comped} {comped === 1 ? "comp" : "comps"})</span>
        )}
      </div>
    </div>
    <div className="bg-green-50 p-4 rounded-lg border border-green-200">
      <div className="text-2xl font-bold text-green-600">
        {redeemed}
      </div>
      <div className="text-sm text-green-800">Redeemed</div>
    </div>
    <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200">
      <div className="text-2xl font-bold text-yellow-600">
        {unredeemed}
      </div>
      <div className="text-sm text-yellow-800">Unredeemed</div>
    </div>
  </div>
)
